<template>
  <div class="c-dialog-header">
    <div><!--{{$t('Cancel')}}--></div>
    <div>{{title}}</div>
    <div>
      <slot>
        <span @click="$emit('close')" class="close" :style="{backgroundImage: `url(${require('@/assets/image/base/close/icons_24pt_close_1.svg')})`}"></span>
      </slot>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    logoName: {
      type: String,
      default: 'close_1.png'
    },
    hasClose: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    /** 关闭 */
    _close() {
      this.$emit('close')
    }
  },
  components: {
    HsClose: () => import('base/hs-close/hs-close')
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.c-dialog-header
  @extend .flex-row
  @extend .flex-between
  width 100%
  height 48px
  padding 0 10px
  >div
    @extend .flex-center
    height 100%
    &:nth-child(1)
      width 2rem
      font-size 1rem
      color $color_gray_text
    &:nth-child(2)
      @extend .hs-font-subtitle-big
      color $color_black_900
    &:nth-child(3)
      width 2rem
      >span
        width 24px
        height 24px
        background-size 100% 100%
        background-repeat no-repeat
</style>
